import { Button } from '@warp-ds/react';
import cn from 'classnames';
import { type KeyboardEvent, useRef } from 'react';

import { useBreakpoints } from '../../hooks/useBreakpoints';

interface CloseCalendarButtonProps {
    onClick: () => void;
    setOpen: (open: boolean) => void;
    text: string;
    className?: string;
}

export const CloseCalendarButton = ({ onClick, setOpen, text, className }: CloseCalendarButtonProps) => {
    const closeButtonRef = useRef<HTMLButtonElement>(null);
    const isSmallScreen = useBreakpoints({ breakpoint: 640 });

    const handleCloseClick = () => {
        onClick();
        setOpen(false);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleCloseClick();
        }
    };

    return (
        <Button
            className={cn(className, 'w-full max-w-full md:w-auto md:max-w-auto')}
            primary
            // @ts-ignore: TODO typedefs from @fabric-ds is confusing the build somehow.. remove when fabric is gone.
            fullWidth
            small={!isSmallScreen}
            ref={closeButtonRef}
            aria-label="bruk valgt dato"
            onClick={handleCloseClick}
            onKeyDown={handleKeyDown}>
            {text}
        </Button>
    );
};
